import React from "react";
import { isCreditUsed } from "../apiContract";
import { fmtOrderRupee } from "../../pages/storeSalesDashboardHelpers";

export default function CreditUsageIndicator({
  credit_adjustments_total,
  credit_note_identifiers,
  compact = false,
}) {
  const used = isCreditUsed({ credit_adjustments_total });
  const total = Number(credit_adjustments_total) || 0;
  const ids = Array.isArray(credit_note_identifiers)
    ? credit_note_identifiers.filter(Boolean)
    : [];

  if (!used) {
    return null;
  }

  const idSuffix = ids.length > 0 ? ` (${ids.join(", ")})` : "";

  return (
    <span className={`text-success ${compact ? "small fw-semibold" : "fw-semibold"}`}>
      Credit applied: {fmtOrderRupee(total)}
      {!compact && idSuffix ? (
        <span className="text-muted fw-normal">{idSuffix}</span>
      ) : null}
    </span>
  );
}
